<template>
  <div style="position: relative">
    <div id="anchor-container" class="anchor-container2" style="text-align: left;padding-left: 20px;padding-right: 260px;">
      <div style="font-size: 32px; margin-bottom: 15px;">{{ myData.title }}</div>
      <div style="font-size: 16px;margin-bottom: 30px;">{{ myData.description }}</div>
      <div v-for="(item,index) in myData.values" :key="index">
        <div v-if="item.type==='text'">
          <div :id="item.name" class="text-title">{{ item.title }}</div>
          <div v-html="item.content"></div>
        </div>
        <div v-else>
          <el-image :src="require('@/assets/images/introduction/'+item.content)" style="width:600px;"></el-image>
        </div>
      </div>
      <div style="text-align: right;color: #919191;font-size: 14px;margin-top: 80px">上次更新：{{ myData.date }}</div>
      <el-divider></el-divider>
      <div class="box">
        <div class="box-left"><el-button type="text" icon="el-icon-arrow-left" @click="toClass(beforeType,beforeName)">{{ before }}</el-button></div>
        <div class="box-right"><el-button type="text" @click="toClass(afterType,afterName)">{{ after }}<i class="el-icon-arrow-right el-icon--right"></i></el-button></div>
      </div>
      <div style="height: 400px"></div>
    </div>
    <div style="display: flex;position: absolute;top:100px;right: 40px" class="anchor">
      <div style="flex: 1"></div>
      <t-anchor :affix-props="{ offsetTop: 50}" :bounds="150" container="#anchor-container" @click="handleClick">
        <t-anchor-item v-for="(item,index) in myData.values" :key="index" :href="'#'+item.name" :title="item.title"></t-anchor-item>
      </t-anchor>
    </div>
    <el-backtop target=".anchor-container2" :right="60" :bottom="80"></el-backtop>
  </div>
</template>

<script>
import { Anchor } from 'tdesign-vue'
import { AnchorItem } from 'tdesign-vue'
import { dataList } from '@/views/introduction/components/dataList'
// 引入组件库的少量全局样式变量
import 'tdesign-vue/es/style/index.css'
export default {
  name: 'Model',
  components: {
    tAnchor: Anchor,
    tAnchorItem: AnchorItem
    // FixedHeader
  },
  data() {
    return {
      myData: {},
      before: '',
      beforeType: '',
      beforeName: '',
      after: '',
      afterType: '',
      afterName: ''
    }
  },
  watch: {
    // 必须加wathc函数，否则不会跳转
    '$route'(to, from) {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
  },
  methods: {
    handleClick({ e, href, title }) {
      e.preventDefault()
      console.log('click', href, title)
    },
    fetchData() {
      console.log('获得数据了')
      console.log(this.$route.params.type + this.$route.params.name)
      // console.log(this.$route.query.type + this.$route.query.name)
      // 返回找到位置下标
      // 路径中冒号：参数，this.$route.params.来取得
      const i = dataList.findIndex(val => (val.type === this.$route.params.type && val.name === this.$route.params.name))
      // 如果用query设置，则$route.query.获取
      // const i = dataList.findIndex(val => (val.type === this.$route.query.type && val.name === this.$route.query.name))
      console.log(i)
      this.myData = dataList[i]
      if (i > 0) {
        // 上一步的标题
        this.before = dataList[i - 1].title
        this.beforeType = dataList[i - 1].type
        this.beforeName = dataList[i - 1].name
      } else {
        this.before = ''
        this.beforeType = ''
        this.beforeName = ''
      }
      if (i < dataList.length) {
        // 下一步
        this.after = dataList[i + 1].title
        this.afterType = dataList[i + 1].type
        this.afterName = dataList[i + 1].name
      } else {
        this.after = ''
        this.afterType = ''
        this.afterName = ''
      }
    },
    toClass(typeString, nameString) {
      if (typeString !== '') {
        // this.$router.push({
        //   path: '/index/introduction/model',
        //   query: { type: typeString, name: nameString }
        // })
        this.$router.push({
          path: `/index/introduction/model/${typeString}/${nameString}`
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h4{
  border-left: 5px solid #409EFF;
  padding-left: 10px;
}
::v-deep p::before {
  content: "\2022"; /* 使用Unicode编码，表示为圆点 */
  margin-right: 0.5em;
  color: #494949;
  font-size: 1.2em;
}
#anchor-container {
  flex-grow: 1;
  height: 800px;
  //overflow: auto;
  position: relative;
  overflow-y: scroll;
  color: #5d5c5c;
  > div {
    //text-align: center;
    //font-size: 22px;
    //line-height: 100px;
  }

  // 如果v-html中样式要有效，则应该加上::v-deep
  ::v-deep a{
    // 取消下划线
    text-decoration: none;
  }
  ::v-deep a:link {
    color: #409EFF;
    text-underline: #FFFFFF;
  }
  ::v-deep a:hover {
    color: #99c9fa;
    text-underline: #409EFF;
  }
  ::v-deep a:visited{
    color: #409EFF;
  }
}
#anchor-container::-webkit-scrollbar {
  width: 5px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
}
#anchor-container::-webkit-scrollbar-track {
  box-shadow: 0px 1px 3px #FFFFFF inset; /*滚动条的背景区域的内阴影*/
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #FFFFFF; /*滚动条的背景颜色*/
}
#anchor-container::-webkit-scrollbar-thumb {
  box-shadow: 0px 1px 3px #e3e4e5 inset; /*滚动条的内阴影*/
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #e3e4e5; /*滚动条的背景颜色*/
}
.text-title{
  font-size: 22px;
  margin-top: 60px;
  margin-bottom: 25px;
  border-left: 5px solid #409EFF;
  padding-left: 10px;
}
.text-image {
  width: 600px;
  height: 350px;
}

::v-deep .text-red {
  color: #5d5c5c;
  font-stretch: normal;
  font-weight: bold;
}

.header {
  background-color: #f1f1f1;
  padding: 20px;
  text-align: center;
  height: 25px;
}

.menu {
  padding: 1px 10px;
  background-color: #f1f1f1;
}

.content {
  margin-left: 15%;
  padding: 1px 16px;
}
.box{
  display: flex;
  justify-content: space-between;
}
.box-left{
  width: 48%;
}
.box-right{
  width: 48%;
  text-align: right;
}
// 修改锚点的颜色
.anchor{
  --td-text-color-primary:#5d5c5c !important;
  // 激活颜色
  --td-brand-color:#409EFF !important;
}
</style>
